import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sgzp-app2-unblock',
  templateUrl: './sgzp-app2-unblock.component.html',
  styleUrls: ['./sgzp-app2-unblock.component.css', '../style/global.css'],
})
export class SgzpApp2UnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href =
      environment.apps[this.clientId]?.sgzpApp2.unblockRedirectUrl;
  }
}
